/* eslint-disable */
import _ from 'underscore';
import Backbone from 'backbone';
import ko from 'knockout';
import pageContext from '@bingads-webui-static-legacy/page-context';
import * as i18nErrors from '@bingads-webui-component-legacy/api-errors-campaign/index';
import jsdata from '@bingads-webui-component-legacy/js-data-campaign/index';
import withUiBlock from '@bingads-webui-component-legacy/uiblocker/index';
import * as scrollUtil from '@bingads-webui-component-legacy/extension/scrollTo';
import ViewModel from '@bingads-webui-campaign-legacy/budget/viewmodel/create';
import createTemplate from '@bingads-webui-campaign-legacy/budget/template/create.pug';
import * as _PerformanceGrid from '@bingads-webui-campaign-legacy/budget/view/performance-grid';
import * as _AdgroupBidGrid from '@bingads-webui-campaign-legacy/budget/view/adgroup-bid-grid';
import * as _AdvancedSettingsView from '@bingads-webui-campaign-legacy/advanced-settings/view/advancedSettings';
import * as _BudgetPanelView from '@bingads-webui-campaign-legacy/budget/view/budget-panel';
import * as _BiddingStrategyView from '@bingads-webui-campaign-legacy/bidding-strategy/view/setting';
import biddingStrategyType from '@bingads-webui-campaign-legacy/bidding-strategy/bidding-strategy-type';
import * as _SharedBudgetView from '@bingads-webui-campaign-legacy/shared-budget/view/shared-budget-switch-editor';
import * as trafficRequestFormatter from '@bingads-webui-campaign-legacy/budget/shared/formatter';
import * as DefaultBid from '@bingads-webui-campaign-legacy/budget/shared/defaultBid';
import * as locationFilters from '@bingads-webui-campaign-legacy/location-targets/util/filters';
import timeZoneMapper from '@bingads-webui-component-legacy/timezonemapper/index';
import instrumentation from '@bingads-webui-static-legacy/instrumentation/index';
import constants from '@bingads-webui-static-legacy/instrumentation/constants';
import config from '@bingads-webui-component-legacy/config/index';
import * as audienceCampaignLoader from '@bingads-webui-campaign-legacy/audience-campaign/loader';
import * as locationTargetTypes from '@bingads-webui-campaign-legacy/location-targets/util/locationTargetTypes';
import * as _getBidSuggestion from '@bingads-webui-campaign-legacy/budget/shared/getBudgetBidSuggestion';
import * as _getTrafficEstimationWithSuggestedBid from '@bingads-webui-campaign-legacy/budget/shared/getTrafficEstimationWithSuggestedBid';
import * as _logger from '@bingads-webui-campaign-legacy/budget/shared/log';
import * as campaignInstrumentation from '@bingads-webui-campaign-legacy/instrumentation/index';
import decimal from '@bingads-webui-component-legacy/humanize/decimal';
import * as POUtils from '@bingads-webui-campaign/personalized-offer-shared';
import state from '@bingads-webui-component-legacy/state/index';
import * as goalSelector from '@bingads-webui-campaign-react/goal-selector';
var i18n = window.globalLegacyI18n.get('component/i18n/loader!campaignui/campaign-creation-advanced');
var AdgroupBidGrid = _AdgroupBidGrid.AdgroupBidGridView;
var BudgetPanelView = _BudgetPanelView.default;
var BiddingStrategyView = _BiddingStrategyView.default;
var AdvancedSettingsView = _AdvancedSettingsView.default;
var SharedBudgetView = _SharedBudgetView.default;
var PerformanceGrid = _PerformanceGrid.PerformanceGridView;
var AudienceAdvancedTargetSettings = audienceCampaignLoader.AudienceAdvancedTargetSettings;
var AudienceTargetInfo = audienceCampaignLoader.AudienceTargetInfo;
var getBidSuggestion = _getBidSuggestion.getBidSuggestion;
var getTrafficEstimationWithSuggestedBid = _getTrafficEstimationWithSuggestedBid.default;
var IsSuggestionInCampaignCreationWorkflowEnabled = pageContext.Permissions.IsSuggestionInCampaignCreationWorkflowEnabled;
var IsSuggestionInCampaignCreationWorkflowVNextEnabled = pageContext.Permissions.IsSuggestionInCampaignCreationWorkflowVNextEnabled;
var dynamicPermissions = _.result(pageContext.Permissions, 'dynamic', {});
var showDisclaimerBanner = _.result(dynamicPermissions, 'AgeGenderDisclaimer', false);
var logBidAdoption = _logger.logBidAdoption;
var logBudgetAdoption = _logger.logBudgetAdoption;
var logBidView = _logger.logBidView;
var activity = campaignInstrumentation.default.suggestionInCreationWorkflow.create().campaignCreation.create();
var bidRange = config.get('KeywordBidRange');
var MAX_NUMBER_OF_KEYWORD = 1000;
const bidSugggestionNewApi = '/Customers(:advertisercustomer_id)/Accounts(:account_id)/Default.CampaignTrafficEstimateWithSuggestedBid';
var View = Backbone.View.extend({
  initialize: function (options) {
    this.options = options || ({});
    if (this.options && this.options.perfMarker) {
      this.showBudgetAndBidMarker = this.options.perfMarker.createChild('Show_Budget_And_Bid', {
        autoEnd: true
      });
      this.showBudgetAndBidMarker.willInit();
    }
    this.ko_model = new ViewModel();
    this.isSuggestionInCampaignCreationWorkflowEnabled = !!this.options.isForVNext && IsSuggestionInCampaignCreationWorkflowVNextEnabled || !this.options.isForVNext && IsSuggestionInCampaignCreationWorkflowEnabled;
    this.biddingStrategyView = new BiddingStrategyView({
      biddingStrategyType: biddingStrategyType.enhancedCPC,
      isInitialize: true,
      isCreation: true,
      campaignType: this.options.campaignType,
      activityLogger: this.options.activityLogger,
      i18nNewDesign: options.i18nNewDesign,
      ccJsData: options.ccJsData,
      isBroadMatchOnlyCampaign: false
    });
    this.supportCashbackSettings = options.supportCashbackSettings;
    var isBidEditable = (function () {
      var type = this.biddingStrategyView.getValues().Type;
      this.ko_model.isbiddingStrategyTypeCPC(type === biddingStrategyType.enhancedCPC);
      return type === biddingStrategyType.enhancedCPC || type === biddingStrategyType.manual;
    }).bind(this);
    this.defaultBid = DefaultBid.defaultBid();
    this.performanceGrid = new PerformanceGrid({
      defaultBid: this.defaultBid,
      isBidEditable: isBidEditable,
      activity: activity,
      suggestionEnabled: this.isSuggestionInCampaignCreationWorkflowEnabled,
      activityLogger: this.options.activityLogger,
      campaignType: this.options.campaignType,
      newI18n: this.options.i18nNewDesign
    });
    this.adgroupBidGrid = new AdgroupBidGrid({
      defaultBid: this.defaultBid,
      isBidEditable: isBidEditable,
      activityLogger: this.options.activityLogger,
      newI18n: this.options.i18nNewDesign
    });
    this.gridView = this.performanceGrid;
    this.performanceGrid.on('bid.updated', (function (adGroups) {
      if (this.performanceGrid.validate()) {
        this.budgetView.updateSuggestedBudget(adGroups);
      }
    }).bind(this));
    this.advancedSettingsView = new AdvancedSettingsView({
      campaignId: '',
      TimeZone: timeZoneMapper.getAccountTimeZone(),
      campaignType: this.options.campaignType,
      activityLogger: this.options.activityLogger,
      newI18n: this.options.i18nNewDesign
    });
  },
  updateGrid: function (adGroups, languages, removePreviousContent) {
    removePreviousContent = _.isUndefined(removePreviousContent) ? true : removePreviousContent;
    if (removePreviousContent) {
      adGroups = _.map(adGroups, function (adgroup) {
        return _.extend(adgroup, {
          suggestedBid: 0,
          isNKW: false,
          viewedSuggestion: false
        });
      });
    }
    this.gridView.update({
      adGroups: adGroups,
      campaignId: this.campaignId,
      budget: this.dailyBudget,
      languages: languages
    });
  },
  fetchSuggestedBid: function (adGroups, languages, spinner) {
    var self = this;
    getTrafficEstimationWithSuggestedBid({
      adGroup: adGroups,
      locations: jsdata.Intermediate.getAll('CampaignCriterion'),
      budget: parseFloat(this.dailyBudget),
      languages: languages
    }, {
      onSuccess: function (res) {
        if (res && res.value && res.value.length) {
          adGroups = _.map(adGroups, function (adgroup, index) {
            var defaultBid = adgroup.suggestedAvgCpc ? Math.max(adgroup.suggestedAvgCpc, self.defaultBid) : self.defaultBid;
            var nkwSuggestion = _.isNull(res.value[index]) ? 0 : res.value[index].Amount;
            var isNKW = nkwSuggestion >= defaultBid;
            var suggestedBid = parseFloat(res.value[index].SuggestedBid).toFixed(2);
            const clicks = parseInt(res.value[index].AdGroupEstimatedTraffic.Clicks);
            const impressions = parseInt(res.value[index].AdGroupEstimatedTraffic.Impressions);
            const reqId = res.suggestedBidRequestId;
            adgroup = _.extend(adgroup, {
              suggestedBid: suggestedBid,
              isNKW: isNKW,
              suggestedClicks: clicks,
              suggestedImpressions: impressions,
              suggestedBidRequestId: reqId
            });
            if (_.isUndefined(adgroup.Bid)) {
              logBidView(adgroup, activity);
            }
            if (_.isUndefined(adgroup.Bid)) {
              if (!_.isUndefined(suggestedBid) && suggestedBid > 0) {
                adgroup.Bid = decimal.fromFloatToString(suggestedBid, 2);
                adgroup.viewedSuggestion = true;
              } else {
                adgroup.Bid = self.defaultBid;
                adgroup.viewedSuggestion = true;
              }
            } else {
              adgroup.viewedSuggestion = false;
            }
            return adgroup;
          });
          self.updateGrid(adGroups, languages, false);
        } else {
          self.updateGrid(adGroups, languages);
        }
      },
      onRequestError: function () {
        self.updateGrid(adGroups, languages);
      },
      onServiceNotSupported: function () {
        self.updateGrid(adGroups, languages);
      },
      onNonSupported: function () {
        self.updateGrid(adGroups, languages);
      }
    }, {
      spinner: spinner
    }, bidSugggestionNewApi);
  },
  willShow: function () {
    var numKeywords = _.sumBy(this.options.context.get('AdGroups'), function (adgroup) {
      return _.isUndefined(adgroup.Keywords) ? 0 : adgroup.Keywords.length;
    });
    this.canFetchSuggestion = numKeywords <= MAX_NUMBER_OF_KEYWORD && this.isSuggestionInCampaignCreationWorkflowEnabled;
    window.scrollTo(0, 0);
    this.ko_model.hasChanges(false);
    var budgetFactory = SharedBudgetView.newFactory(BudgetPanelView);
    var languages;
    var campaignId;
    if (_.isObject(this.options.context)) {
      var campaignObj = this.options.context.get('Campaign');
      if (!_.isUndefined(campaignObj)) {
        if (_.isObject(campaignObj.Budget)) {
          this.initBudget = campaignObj.Budget.Amount;
          languages = campaignObj.Languages;
          campaignId = campaignObj.Id;
        }
      }
    }
    this.budgetView = budgetFactory({
      model: _.isObject(this.model) ? this.model.budget : {},
      initBudget: this.initBudget,
      haveBudgetSuggestion: this.canFetchSuggestion,
      languages: languages,
      campaignId: campaignId,
      activity: activity,
      perfMarker: this.showBudgetAndBidMarker,
      isForVNext: this.options.isForVNext,
      activityLogger: this.options.activityLogger
    });
    this.$('.budget').empty().html(this.budgetView.render().el);
    this.budgetView.on('budget.updated', (function (dailyBudget) {
      this.performanceGrid.update({
        budget: parseFloat(dailyBudget)
      });
      if (this.performanceGrid.validate()) {
        this.budgetView.updateSuggestedBudget(this.performanceGrid.getAdGroupsData(), true);
      }
    }).bind(this));
    if (_.isObject(this.options.context)) {
      var campaignObj = this.options.context.get('Campaign');
      if (!_.isUndefined(campaignObj)) {
        this.campaignId = campaignObj.Id;
        this.campaignName = campaignObj.Name;
        this.budgetView.update(campaignObj.Budget);
        this.initialBudget = campaignObj.Budget.Amount;
        this.dailyBudget = trafficRequestFormatter.getDailyBudgetAmount(campaignObj.Budget);
        this.ko_model.estimateTrafficSupported(true);
        this.gridView = this.ko_model.showAdgroupBidGrid() ? this.adgroupBidGrid : this.performanceGrid;
        this.canFetchSuggestion = this.canFetchSuggestion && this.ko_model.showPerformanceGrid();
        if (this.canFetchSuggestion) {
          if (this.options && this.options.perfMarker) {
            this.fetchSuggestedBidMarker = this.options.perfMarker.createChild('Fetch_Suggested_Bid');
            this.fetchSuggestedBidMarker.willInit();
            this.fetchSuggestedBidMarker.willFetchData();
          }
          this.fetchSuggestedBid(this.options.context.get('AdGroups'), campaignObj.Languages, this.$('.grid'));
          if (this.fetchSuggestedBidMarker) {
            this.fetchSuggestedBidMarker.done();
          }
        } else {
          this.fetchSuggestedBid(this.options.context.get('AdGroups'), campaignObj.Languages, this.$('.grid'));
        }
        if (!_.isEmpty(campaignObj.BiddingScheme)) {
          this.biddingStrategyView.update(campaignObj.BiddingScheme);
        }
        if (this.advancedSettingsView) {
          this.advancedSettingsView.update(campaignObj.Languages);
        }
        this.initCampaignTargets(_.defaults({
          CampaignType: this.options.campaignType
        }, campaignObj));
        this.updateCampaignTargets();
        if (pageContext.Permissions.IsPersonalizedOffersEnabled) {
          var subViewsNeedToUpdateCashbackColumn = _.compact([this.campaignTargetsView, this.advancedSettingsView.adScheduleView, this.advancedSettingsView.locationTargetsView]);
          var shouldShowCashbackColumn = POUtils.shouldSupportCashbackSettings(campaignObj, pageContext.Permissions);
          subViewsNeedToUpdateCashbackColumn.forEach(function (subView) {
            subView.toggleCashbackPercentColumns(shouldShowCashbackColumn, {
              level: 'Campaign',
              value: campaignObj.CampaignCashback && campaignObj.CampaignCashback.Percent
            });
          });
          if (pageContext.Permissions.IsPersonalizedOffersV2Enabled || pageContext.Permissions.IsPersonalizedOffersV3Enabled) {
            this.biddingStrategyView.setPersonalizedOffersOptionsAndValue({
              enabled: shouldShowCashbackColumn,
              campaignType: this.options.campaignType
            });
          }
        }
        const params = {
          queryParameters: {
            entitySet: campaignObj,
            expand: ['CampaignConversionGoal/Goals']
          },
          bypassCache: true
        };
        jsdata.Campaign.find(Number(campaignObj.Id), params).then(campaign => {
          const isSPA = campaign.CampaignSubType === 'ShoppingSponsoredProductAd';
          const isCPS = campaign.CampaignCashback != null && (campaign.CampaignCashback.PersonalizedOffersEnabled === true || campaign.CampaignCashback.MonthlyBudget > 0);
          const isSelectorEnabled = !isSPA && !isCPS;
          if (isSelectorEnabled) {
            this.campaignGoalSelectionView = new goalSelector.GoalSelectorView({
              i18n: i18n.realI18n,
              pageSize: 10,
              isMultiMode: true,
              isHideSaveBar: true,
              campaign,
              jsdata,
              state
            });
            this.$('.conversion-goal-selector').empty().html(this.campaignGoalSelectionView.render().el);
            this.ko_model.isCampaignLevelGoalEnabled(true);
          } else {
            this.ko_model.isCampaignLevelGoalEnabled(false);
          }
          if (pageContext.Permissions.dynamic.BroadOnly && !pageContext.Permissions.dynamic.PredictiveMatching) {
            this.biddingStrategyView.viewModel.isBroadMatchOnlyCampaign(campaign && campaign.IsBroadMatchOnlyCampaign);
          }
        });
      }
    }
  },
  hasChanges: function () {
    return this.ko_model.hasChanges();
  },
  events: {
    'show.bs.collapse .campaign-targets': 'onShowCampaignTargets',
    'hide.bs.collapse .campaign-targets': 'onHideCampaignTargets'
  },
  onShowCampaignTargets: function () {
    this.ko_model.isCampaignTargetsExpanded(true);
  },
  onHideCampaignTargets: function () {
    this.ko_model.isCampaignTargetsExpanded(false);
  },
  initCampaignTargets: function (campaign) {
    if (this.campaignTargetsView) {
      return;
    }
    var audienceTargetInfo = new AudienceTargetInfo({
      resourceName: 'CampaignCriterion',
      listenToLocationCriterion: false,
      useLocationControl: false,
      initAudienceAssociationView: false
    });
    this.campaignTargetsView = new AudienceAdvancedTargetSettings({
      viewContext: {
        accountCurrencyCode: pageContext.AccountCurrencyCode,
        currentCampaign: campaign,
        level: 'campaign'
      },
      scenario: 'campaign-creation',
      currentLevelTargetInfo: audienceTargetInfo,
      activityLogger: this.options.activityLogger
    });
    this.$('.campaign-targets').empty().html(this.campaignTargetsView.render().el);
    if (_.has(this.advancedSettingsView, 'locationTargetsView')) {
      this.campaignTargetsView.$('.location-setting-controller').append(this.advancedSettingsView.locationTargetsView.render().el);
    }
  },
  updateCampaignTargets: function () {
    if (!this.campaignTargetsView) {
      return;
    }
    var criterions = jsdata.Intermediate.getAll('CampaignCriterion');
    var shouldShow = _.find(criterions, function (criterion) {
      return criterion.SelectionStatus === locationTargetTypes.Included;
    });
    if (shouldShow) {
      this.campaignTargetsView.$('.selection-item-container[data-key=location]').removeClass('hide');
      this.campaignTargetsView.$('.location-target-setting-container').removeClass('hide');
    } else {
      this.campaignTargetsView.$('.selection-item-container[data-key=location]').addClass('hide');
      this.campaignTargetsView.$('.location-target-setting-container').addClass('hide');
    }
  },
  render: function () {
    this.$el.html(createTemplate({
      i18n: i18n,
      isShowDisclaimerBannerEnabled: showDisclaimerBanner
    }));
    ko.applyBindings(this.ko_model, this.el);
    this.$('.performance-grid').empty().html(this.performanceGrid.render().el);
    this.$('.adgroupbid-grid').empty().html(this.adgroupBidGrid.render().el);
    this.$('.bidding-strategy__container').empty().html(this.biddingStrategyView.render().el);
    this.$('.bidding-strategy__container')[0].addEventListener('change', (function () {
      this.gridView.grid.gridView.refresh(true);
    }).bind(this), false);
    this.$('.budget-bid-settings')[0].addEventListener('change', (function () {
      this.ko_model.hasChanges(true);
    }).bind(this), false);
    if (this.advancedSettingsView) {
      this.$('.advanced-settings-section').empty().html(this.advancedSettingsView.render().el);
    }
    this.biddingStrategyView.viewModel.selectedBidStrategy.subscribe(value => {
      this.advancedSettingsView.onSelectedBidStrategyChange(value);
    });
    return this;
  },
  shouldCancel: function () {
    return this.save();
  },
  shouldBack: function () {
    if (_.isObject(this.options.context)) {
      if (this.budgetView) {
        this.options.context.set('Draft.Budget', this.budgetView.getValues({}));
      }
      if (this.gridView) {
        var origin = this.options.context.get('AdGroups');
        var updated = this.gridView.getAdGroups();
        this.options.context.set('AdGroups', _.map(origin, function (adgroup) {
          _.each(updated, function (updatedAdgroup) {
            if (updatedAdgroup.Id === adgroup.Id) {
              adgroup.Bid = updatedAdgroup.SearchBid;
            }
          });
          return adgroup;
        }));
      }
    }
    return true;
  },
  validate: function () {
    return _.reduce([this.budgetView.validate(), this.advancedSettingsView.validate(), this.gridView ? this.gridView.validate() : true, this.biddingStrategyView.validate(), this.campaignTargetsView ? this.campaignTargetsView.validate() : true], function (memo, val) {
      return memo && val;
    }, true);
  },
  enough: function () {
    return _.every([this.budgetView.enough(), this.gridView ? this.gridView.enough() : true]);
  },
  errorElements: function () {
    return this.$('.budget-bid-settings .error, .budget-bid-settings .alert-danger').filter(':visible');
  },
  logBidAdoption: function (adGroups) {
    _.each(adGroups, function (adgroup) {
      logBidAdoption(adgroup, activity);
    });
  },
  logBidSuggestion: function (adGroups) {
    _.each(adGroups, function (adgroup) {
      instrumentation.logMessage([constants.LOGCATEGORY.SUBSTRATE], constants.LOGLEVEL.INFO, 'CreationFlowBidSave', JSON.stringify({
        Scenario: 'CampaignCreation',
        SuggestedBid: adgroup.suggestedBid,
        SaveBid: adgroup.SearchBid,
        EventName: 'CreationFlowBidSave',
        SuggestedBidRequestId: adgroup.suggestedBidRequestId,
        CampaignId: adgroup.Campaign.Id,
        AdgroupId: adgroup.Id,
        CurrencyId: pageContext.AccountCurrencyCode
      }));
    });
  },
  logBudgetAdoption: function (campaign, suggestedBudget) {
    if (_.isUndefined(campaign.BudgetId) || _.isNull(campaign.BudgetId)) {
      if (!_.isUndefined(suggestedBudget)) {
        logBudgetAdoption({
          Id: campaign.Id,
          suggestedBudget: suggestedBudget,
          budget: campaign.Budget.Amount,
          initBudget: this.initBudget
        }, activity);
      }
    }
  },
  save: function () {
    var self = this;
    if (!this.validate()) {
      scrollUtil.scrollAndCenter(this.errorElements());
      return false;
    }
    var saveBudgetAndBidMarker = null;
    if (this.options && this.options.perfMarker) {
      saveBudgetAndBidMarker = this.options.perfMarker.createChild('Save_Budget_And_Bid');
      saveBudgetAndBidMarker.willInit();
    }
    this.clearApiErrors();
    var adGroups = this.gridView.getAdGroups();
    var campaignToSave = {
      Id: this.campaignId,
      Name: this.campaignName,
      AdGroups: _.map(adGroups, function (adgroup) {
        adgroup.Status = 'Active';
        return _.omit(adgroup, ['isNKW', 'suggestedBid', 'viewedSuggestion', 'SuggestedBidRequestId']);
      })
    };
    campaignToSave.Budget = this.budgetView.getValues(campaignToSave);
    const biddingSchema = this.biddingStrategyView.getValues();
    campaignToSave['BiddingScheme'] = biddingSchema;
    if (pageContext.Permissions.dynamic.RSABidStrategyAutoTargeting && !pageContext.Permissions.dynamic.PredictiveMatching && this.options.campaignType === 'search') {
      campaignToSave.AutoTargetingEnabled = biddingSchema.AutoTargetingEnabled || false;
    }
    var advancedSettings = this.advancedSettingsView.getValues();
    if (pageContext.Permissions.dynamic.PredictiveMatching) {
      campaignToSave.AutoTargetingEnabled = advancedSettings.AutoTargetingEnabled || false;
    }
    var dateSettings = advancedSettings.dateSettings;
    var netWorkOptions = advancedSettings.netWorkOptions;
    _.each(campaignToSave.AdGroups, function (adGroup) {
      _.extend(adGroup, dateSettings, netWorkOptions);
    });
    this.populateCriterionCampaignIds(advancedSettings.deviceTargets);
    this.populateCriterionCampaignIds(advancedSettings.locationTargets);
    this.populateCriterionCampaignIds(advancedSettings.scheduling);
    campaignToSave.CampaignCriterions = advancedSettings.deviceTargets.concat(advancedSettings.locationTargets).concat(advancedSettings.scheduling);
    if (this.campaignTargetsView) {
      var campaignTargetsData = this.campaignTargetsView.getData();
      var campaignTargetsCriterions = _.result(campaignTargetsData, 'CampaignCriterions', []);
      campaignTargetsCriterions = _.map(campaignTargetsCriterions, function (criterion) {
        return _.defaults({
          Campaign: {
            Id: campaignToSave.Id
          }
        }, criterion);
      });
      campaignToSave.CampaignCriterions = campaignToSave.CampaignCriterions.concat(campaignTargetsCriterions);
    }
    _.extend(campaignToSave, advancedSettings.nativeAds);
    _.extend(campaignToSave, advancedSettings.multimediaAds);
    _.extend(campaignToSave, advancedSettings.vanityUrlSettings);
    if (this.advancedSettingsView && this.advancedSettingsView.adScheduleView) {
      campaignToSave.AdScheduleUseSearcherTimeZone = _.result(this.advancedSettingsView.adScheduleView, 'getAdScheduleUseSearcherTimeZone');
    }
    if (this.campaignGoalSelectionView) {
      campaignToSave.CampaignConversionGoalAssociations = this.campaignGoalSelectionView.convertToMTFormat(this.campaignId);
    }
    return jsdata.Campaign.update(this.campaignId, campaignToSave, {
      adapter: 'bulk'
    }).then(function (res) {
      var targetToCountMapping = {};
      _.each(res.CampaignCriterions, function (criterion) {
        var targetKey = criterion.Criterion.Type === 'Location' || criterion.Criterion.Type === 'Radius' ? 'update' + criterion.SelectionStatus + criterion.Criterion.Type + 'Targets' : 'create' + criterion.Criterion.Type + 'Targets';
        var count = targetToCountMapping[targetKey];
        targetToCountMapping[targetKey] = (_.isUndefined(count) ? 0 : count) + 1;
      });
      for (var target in targetToCountMapping) {
        var count = targetToCountMapping[target];
        if (count > 0) {
          instrumentation.logMessage([constants.LOGCATEGORY.TRACE], constants.LOGLEVEL.INFO, target, count);
        }
      }
      if (saveBudgetAndBidMarker) {
        saveBudgetAndBidMarker.done();
      }
      if (self.canFetchSuggestion) {
        self.logBidAdoption(adGroups);
        self.logBudgetAdoption(campaignToSave, self.budgetView.getSuggestedBudget());
      }
      self.logBidSuggestion(adGroups);
      return true;
    }).catch((function (response) {
      i18nErrors.getPartial(response, ['AdGroups', 'CampaignCriterions']);
      this.advancedSettingsView.setData(response);
      response.errors = this.advancedSettingsView.handleErrors(response);
      if (this.campaignTargetsView) {
        this.campaignTargetsView.fillCriterionsWithId(_.result(response.entity, 'CampaignCriterions'));
      }
      this.ko_model.errors.add(i18nErrors.getBulkApiErrors(response.errors));
      scrollUtil.scrollAndCenter(this.errorElements());
      if (this.options.activityLogger) {
        _.chain(response.errors).map(function (error) {
          return error.Error;
        }).uniq().each(function (error) {
          this.options.activityLogger.signal(error, 'campaign budget api error');
        }, this);
      }
      return false;
    }).bind(this)).finally(withUiBlock());
  },
  clearApiErrors: function () {
    this.advancedSettingsView.clearApiErrors();
    this.ko_model.errors.clear(i18nErrors.isCampaignApiError);
  },
  populateCriterionCampaignIds: function (criterions) {
    _.each(criterions, function (criterion) {
      criterion.Status = _.isEmpty(criterion.Status) ? 'Active' : criterion.Status;
      criterion.Campaign = {
        Id: this.campaignId
      };
    }, this);
  },
  remove: function () {
    if (this.performanceGrid) {
      this.performanceGrid.remove();
    }
    if (this.adgroupBidGrid) {
      this.adgroupBidGrid.remove();
    }
    if (this.biddingStrategyView) {
      this.biddingStrategyView.remove();
    }
    if (this.advancedSettingsView) {
      this.advancedSettingsView.remove();
    }
    if (this.campaignTargetsView) {
      this.campaignTargetsView.remove();
    }
    if (this.campaignGoalSelectionView) {
      this.campaignGoalSelectionView.remove();
    }
    Backbone.View.prototype.remove.apply(this, arguments);
  }
});
export default View;

